export default "__VITE_ASSET__y08h5ugi__"